import React, { useState } from 'react';
import { useField } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { formatDate } from '../../../services';
import InfoIcon from '../../../assets/icons/ic-info.svg';
import { useTooltipWithScrollClose } from '../../../hooks/useTooltipWithScrollClose';

interface IProps {
  name: string;
  labelText?: string;
  toolTipText?: string;
  disabled?: boolean;
  required?: boolean;
  newData?: any;
  oneField?: any;
  backgroundColour?: string | null;
}

const CALENDAR_DATE_FORMAT = 'dd.MM.yyyy';

const DateInput = ({
  name,
  labelText,
  toolTipText = '',
  disabled = false,
  required = false,
  newData,
  oneField,
  backgroundColour
}: IProps) => {
  const [field, meta, helpers] = useField(name);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showTooltip, setShowTooltip] = useTooltipWithScrollClose();
  const changeFieldsValue = checkedValue => {
     
    const findField = newData?.Pages?.map(tab =>
      tab?.Fields?.forEach(f => {
        if (f.Template.ID === oneField.Template.ID) {
          f.Value = checkedValue || null;
        }
      }),
    );
    // setFieldValue(field.name, checkedValue)
  };
  return (
    <div className="form-group">
      {labelText && (
        <div className={`label-wrapper ${toolTipText && 'with-tooltip'}`}>
          {/* Icon must stay OUTSIDE <label> — the label's htmlFor points to the
              datepicker input, so clicking an icon inside it would open the
              calendar instead of the tooltip. */}
          <label htmlFor={field.name}>
            {required && <span className="required-indicator">*</span>}
            {labelText}
          </label>
          {toolTipText && (
            <OverlayTrigger
              trigger="click"
              rootClose
              placement="bottom"
              show={showTooltip}
              onToggle={setShowTooltip}
              overlay={
                <Tooltip id={`tooltip-${field.name}`}>{toolTipText}</Tooltip>
              }
            >
              <img
                src={InfoIcon}
                alt="info img"
                className="tooltip-trigger"
                data-toggle="tooltip"
              />
            </OverlayTrigger>
          )}
        </div>
      )}
      <div style={{ backgroundColor: backgroundColour || undefined }}>
        <DatePicker
          {...field}
          dateFormat={CALENDAR_DATE_FORMAT}
          value={
            field?.value && new Date(field.value).toString().substring(4, 15)
          }
          selected={field?.value && new Date(field?.value)}
          className={`form-control ${meta.error && 'is-invalid'}`}
          name={field.name}
          id={field.name}
          onChange={val => {
            if (!disabled) {
              helpers.setValue(new Date(val as Date).toISOString());
              changeFieldsValue(new Date(val as Date).toISOString())
            }
          }}
          disabled={disabled}
        />
      </div>
      {meta.error && <p className="error-wrapper">{meta.error}</p>}
    </div>
  );
};

export { DateInput };
